// extracted by mini-css-extract-plugin
export var cardLayout = "_66-1";
export var paginationContainer = "_66-0";